import * as Collapsible from '@radix-ui/react-collapsible';

import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Header = styled.div`
  background-color: ${Colors.blue[3]};
  border-top: ${`1px solid ${Colors.black}`};
  cursor: pointer;
  display: flex;
  padding: ${Spacing.Xs};
`;

export const CollapseIcon = styled.div`
  margin-right: auto;
`;

export const Content = styled(Collapsible.Content)<{ $color?: string }>`
  background-color: ${({ $color }) => $color};
  padding: ${Spacing.M};
`;
